import React, { FC, useEffect, useState } from 'react';
import { ApprovalModalProps } from './ApprovalModalProps';
import ApprovalModalComponenet from '../../components/ApprovalModalComponenet';
import { useTypedSelector } from '../../store';
import {
  selectSelectedProject,
  selectApprovalProjects,
} from '../../store/approval/selectors';
import { getFY } from '../../utils/calculation';
import { updateApprovalProjects } from '../../store/approval/actionWrappers';
import { useDispatch } from 'react-redux';
import { FDA_OPTIONS } from '../../components/ApprovalModalPartOfFda/utils';

const ApprovalModal: FC<ApprovalModalProps> = ({
  visible,
  selectedProjects,
  onCloseHandler,
  approvalProjectFetchValues,
}) => {
  const project = useTypedSelector(selectSelectedProject);
  const projects = useTypedSelector(selectApprovalProjects);
  const showDirectiveCaution = selectedProjects.some((id) => {
    const p = projects.find((proj) => proj.id === id);
    return p && p.isDirectiveComplete === false;
  });
  const [isepWasChanged, setIsepWasChanged] = useState(false);
  const [gexChanged, setGexChanged] = useState(null);
  const [isep, setIsep] = useState(false);
  const [partOfFda, setPartOfFda] = useState(null);
  const [partOfFdaChanged, setPartOfFdaChanged] = useState(false);
  const [gex, setGex] = useState(null);
  const [gexDates, setGexDates] = useState(null);
  const [fundedBy, setFundedBy] = useState(null);
  const [ocnPriority, setOcnPriority] = useState(null);
  const [gexComment, setGexComment] = useState('');
  const [isepStatus, setIsepStatus] = useState(null);
  const [validationComment, setValidationComment] = useState(null);
  const [validation, setValidation] = useState(null);
  const [subPortfolio, setSubPortfolio] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsepWasChanged(false);
    setPartOfFdaChanged(false);
    setGexChanged(null);
    setIsep(project?.isep);
    setPartOfFda(project?.partOfFda || FDA_OPTIONS.NO);
    setGex({
      [getFY(-1)]: null,
      [getFY()]: null,
      [getFY(1)]: null,
      ...project?.fiscalYearAlignedWithGEXList?.reduce(
        (acc, { fiscalYear, alignedWithGEXType }) => ({
          ...acc,
          [fiscalYear]: alignedWithGEXType,
        }),
        {},
      ),
    });
    setGexDates({
      ...project?.fiscalYearAlignedWithGEXList?.reduce(
        (acc, { fiscalYear, baselineStartDate, baselineOpeningDate }) => ({
          ...acc,
          [fiscalYear]: baselineStartDate
            ? {
                baselineStartDate,
                baselineOpeningDate,
              }
            : {},
        }),
        {},
      ),
    });
    setFundedBy(project?.fundedBy);
    setOcnPriority(project?.ocnPriority);
    setGexComment(project?.gexComment);
    setIsepStatus(project?.isepStatus);
    setValidationComment(project?.validationComment);
    setValidation(project?.validation);
    setSubPortfolio(project?.subPortfolio);
  }, [project]);
  const isepChangedHandler = (value) => {
    setIsep(value);
    setIsepWasChanged(true);
  };
  const partOfFdaChangedHandler = (value) => {
    setPartOfFda(value);
    setPartOfFdaChanged(true);
  };
  const gexChangedHandler = (fy, value) => {
    const gexChangedCopy = { ...gexChanged, [fy]: value };
    setGexChanged(gexChangedCopy);
    const gexCopy = { ...gex, [fy]: value };
    setGex(gexCopy);
  };
  const fundedByChangedHandler = (value) => {
    setFundedBy(value);
  };
  const ocnPriorityChangedHandler = (value) => {
    setOcnPriority(value);
  };
  const gexCommentChangedHandler = (value) => {
    setGexComment(value);
  };
  const isepStatusChangedHandler = (value) => {
    setIsepStatus(value);
  };
  const validationCommentChangedHandler = (value) => {
    setValidationComment(value);
  };
  const validationChangedHandler = (value) => {
    setValidation(value);
  };
  const subPortfolioChangedHandler = (value) => {
    setSubPortfolio(value);
  };
  const submitHandler = () => {
    dispatch(
      updateApprovalProjects({
        projectIds: selectedProjects,
        approvalProjectFetchValues,
        isep: isepWasChanged ? isep || false : null,
        partOfFda: partOfFdaChanged ? partOfFda : null,
        partOfFdaDate: null,
        fiscalYearAlignedWithGEXMap: gexChanged,
        gexComment,
        fundedBy,
        isepStatus,
        ocnPriorityType: ocnPriority,
        validation,
        validationComment,
        subPortfolio,
      }),
    );
  };
  return (
    <>
      <ApprovalModalComponenet
        isep={isep}
        setIsep={isepChangedHandler}
        partOfFda={partOfFda}
        setPartOfFda={partOfFdaChangedHandler}
        gex={gex}
        gexDates={gexDates}
        setGex={gexChangedHandler}
        fundedBy={fundedBy}
        setFundedBy={fundedByChangedHandler}
        ocnPriority={ocnPriority}
        setOcnPriority={ocnPriorityChangedHandler}
        gexComment={gexComment}
        setGexComment={gexCommentChangedHandler}
        visible={visible}
        onCloseHandler={onCloseHandler}
        submitHandler={submitHandler}
        project={project}
        isepStatus={isepStatus}
        setIsepStatus={isepStatusChangedHandler}
        validationComment={validationComment}
        setValidationComment={validationCommentChangedHandler}
        validation={validation}
        setValidation={validationChangedHandler}
        subPortfolio={subPortfolio}
        setSubPortfolio={subPortfolioChangedHandler}
        showDirectiveCaution={showDirectiveCaution}
      />
    </>
  );
};

export default ApprovalModal;
